export type MapStyle = {
	value: string;
	label: string;
	url: string;
	role?: string;
	contourLines?: boolean;
}

export const mapStyles: MapStyle[] = [
	{
		value: 'alidade_smooth',
		label: 'Light',
		url: "https://tiles-eu.stadiamaps.com/styles/alidade_smooth.json"
	},
	{
		value: 'alidade_smooth_dark',
		label: 'Dark',
		url: "https://tiles-eu.stadiamaps.com/styles/alidade_smooth_dark.json"
	},
	{
		value: 'outdoors',
		label: 'Outdoors',
		url: "/styles/outdoors.json",
		contourLines: true
	},
	{
		value: 'osm_bright',
		label: 'OSM Bright',
		url: "https://tiles-eu.stadiamaps.com/styles/osm_bright.json"
	},
	{
		value: 'snow',
		label: 'Snow',
		url: "/styles/snow.json",
		contourLines: true
	},
	{
		value: 'oslomaraton',
		label: 'Oslo Maraton',
		role: "oslomaraton",
		url: "/styles/oslo_maraton.json",
	},
	{
		value: 'mt_outdoor_sthlmtrail',
		label: 'Stockholm Trail',
		role: "sthlmtrail",
		url: "/styles/trail.json"
	},
	{
		value: 'white',
		label: 'White',
		role: "sthlmtrail",
		url: "/styles/white.json"
	},
	{
		value: 'alidade_satellite',
		label: 'Satellite',
		role: "satellite",
		url: "https://tiles-eu.stadiamaps.com/styles/alidade_satellite.json"
	},
	{
		value: 'norway_topo',
		label: 'Norway Topo',
		url: "/styles/norway.json"
	},
	{
		value: 'norway_topo_routes',
		label: 'Norway Topo with Routes',
		url: "/styles/norway-routes.json",
		role: "birken"
	},
	{
		value: 'norway_topo_routes2',
		label: 'Norway Topo with Routes v2',
		url: "/styles/norway-routes2.json",
		role: "birken"
	},
]